import icon from 'appSrc/v5/assets/logos/logo-small.svg';
import ericPicture from 'appSrc/v5/assets/images/about/7.png';
import judithPicture from 'appSrc/v5/assets/images/about/9.png';
import brianPicture from 'appSrc/v5/assets/images/about/5.png';
import kelsey from 'appSrc/v5/assets/images/about/1.png';
import sofia from 'appSrc/v5/assets/images/about/11.png';
import karl from 'appSrc/v5/assets/images/about/3.png';
import kyle from 'appSrc/v5/assets/images/about/8.png';
import monique from 'appSrc/v5/assets/images/about/6.png';
import camille from 'appSrc/v5/assets/images/about/4.png';
import carleton from 'appSrc/v5/assets/images/about/10.png';
import ali from 'appSrc/v5/assets/images/about/2.png';

var host = process.env.REACT_APP_HOST;
if( icon.includes( 'http' ) ) {
    host = '';
}

export default {
    '@type': 'Organization',
    url: 'https://thedesirecompany.com/',
    sameAs: [
        'https://twitter.com/thedesireco',
        'https://www.instagram.com/the_desire_company/',
        'https://www.facebook.com/thedesirecompany/',
    ],
    name: 'The Desire Company',
    legalName: 'The Desire Company',
    logo: host + icon,
    description: `Shop Honest Product Recommendations from Real Professionals.
No #ads. No Fake Reviews.
Just honest advice.`,
    founders: [
        {
            image: host + ericPicture,
            name: 'Eric Sheinkop',
            jobTitle: 'Co-Founder & CEO',
            description: 'Accomplished entrepreneur, author and Olympic Torch bearer, Eric had the monopoly on lemonade stands in his Lincoln Park, Chicago neighborhood by age 11, going on to build the world’s largest community of independent music artists, securing $35M in brand partnership deals.',
            url: 'https://www.linkedin.com/in/ericsheinkop/',
            '@type': 'Person',
        },
        {
            image: host + judithPicture,
            name: 'Judith Levey',
            jobTitle: 'Co-Founder & COO',
            description: 'Scottish American PR Maven and Glasgow Youth Group Table Tennis champ by age 14, Judith led Global Brand PR for Coca-Cola\'s entertainment and sports sponsorship programs including establishing the company’s first ever global influencer program.',
            url: 'https://www.linkedin.com/in/judith-levey/',
            '@type': 'Person',
        },
    ],
    employees: [
        {
            image: host + kyle,
            name: 'Kyle Trobman',
            jobTitle: 'Head of Content',
            description: 'Though terrified of horror films, Kyle began his career in entertainment working for FEARNET, where he helped streamline their communications and operations. Since then, Kyle has built a career in developing and producing content for high profile networks and brands such as NBC, PBS, Reelz, Netflix, http://Walmart.com, Food Network, P&G, Lionsgate and TODAY Digital. His portfolio ranges from scripted projects to digital series to branded content. He is a graduate from the Film & TV Program at Drexel University in Philadelphia, PA. (Go Eagles!)',
            '@type': 'Person',
        },
        {
            image: host + brianPicture,
            name: 'Brian Crucitti',
            jobTitle: 'Lead Developer',
            description: 'A man of eclectic tastes, from creative writing, tabletop gaming, and learning Japanese to aerial silks and circus arts. Brian is always full of surprises and weird, niche information.',
            url: 'https://www.linkedin.com/in/brian-crucitti-33221032/',
            '@type': 'Person',
        },
        {
            image: host + kelsey,
            name: 'Kelsey Cline',
            jobTitle: 'Head of Partner Operations',
            description: 'Former NBA dancer, raised in Portlandia, and proud USD alum, Kelsey’s love for sports (she grew up right by Nike HQ) led to her role managing an online community and creating digital content for over 250 professional athletes, all while rockin it on the dance floor, including at the 2017 NBA All-star Game.',
            url: 'https://www.linkedin.com/in/kelsey-cline-2343b0b8/',
            '@type': 'Person',
        },
        {
            image: host + ali,
            name: 'Ali Tamashiro',
            jobTitle: 'Marketing Manager',
            description: 'Captivated by the power of a brand\'s impact on its business, Ali is an experienced brand marketer who has built her career working with fast-growing companies to create new digital marketing strategies centered around the new age consumer. She holds a BS in Business Administration from the University of Central Florida and her MBA from Crummer Graduate School of Business. When she is not busy building new campaigns, you can find her running along Chicago’s lakeshore path or being a momager of her little Aussie @coco_theaussiegirl.',
            url: 'https://www.linkedin.com/in/alitamashiro/',
            '@type': 'Person',
        },
        {
            image: host + monique,
            name: 'Monique Filardi',
            jobTitle: 'Head of Business Development',
            description: 'Monique has spent her career building partnerships on a local and enterprise level for some of Chicago\'s fastest growing, venture backed companies. Her analytical approach and understanding of the full marketing lifecycle allows her to build and implement strategies for sustained growth. She is also a certified Pilates instructor and very passionate about her involvement in the animal rescue community in Chicago.',
            url: 'https://www.linkedin.com/in/monique-filardi-4225bb50/',
            '@type': 'Person',
        },
        {
            image: host + carleton,
            name: 'Carleton Koldyke',
            jobTitle: 'Business Development Manager',
            description: 'Carleton has spent most of his life working in and around the city he loves, Chicago. From his first job working concessions at Wrigley Field, to performing in music venues all around the city, and now joining the most exciting startup to come out of the city, Carleton\'s upbeat energy and drive for success embodies the spirit of a true Chicagoan. If you\'re lucky, you can find him singing and playing guitar at one of the many bars he performs at on the weekends.',
            url: 'https://www.linkedin.com/in/carleton-koldyke-165a8257/',
            '@type': 'Person',
        },
        {
            image: host + sofia,
            name: 'Sofia Avendano',
            jobTitle: 'Content Assistant',
            description: 'Born in Guatemala, raised in Texas, but currently living in the midwest, Sofia sometimes has a hard time making up her mind. Her love for writing is a sure thing though— she has a BA in Multimedia Journalism from Columbia College Chicago. Sofia likes goth films, reading at the worst times, and her cat. She still owns the first fashion magazine she ever bought.',
            url: 'https://www.linkedin.com/in/sofia-avendano-743128a7/',
            '@type': 'Person',
        },
        {
            image: host + karl,
            name: 'Karl J. Steltenpohl',
            jobTitle: 'Software Developer',
            description: '10+ years as a software developer in the music and finance industries, Karl is a former 1st place winner of the Chicago Tribune\'s Big Idea Awards for Technology. Has been called a modern-day renaissance man with artist, design, VJ, maker, musician, skater, and sailing skills all combining to create his Chicago lifestyle.',
            url: 'https://www.linkedin.com/in/karl-steltenpohl-26ab338/',
            '@type': 'Person',
        },
        {
            image: host + camille,
            name: 'Camille Sims',
            jobTitle: 'Marketing Assistant',
            description: 'Newly graduated from Florida Atlantic University with a degree in marketing, Camille has a passion for social media and the film industry. Growing up in the Sunshine State, she loves to play tennis or do anything outdoors. She also can smell fear.',
            url: 'https://www.linkedin.com/in/camille-sims-56a992177/',
            '@type': 'Person',
        },
    ],
};
